// Canvas-иконки для line-pattern скал/канаток - вынесены из MapView.vue
// (см. пояснение в constants.ts этой же папки).

// ── Cliffs (скалы/обрывы) ─────────────────────────────────────────────────
// Скальная стенка на любой бумажной топокарте и на самой OpenTopoMap
// рисуется штриховкой - простая цветная линия или прямой перпендикулярный
// штрих читается как «ещё одна тропа другого цвета», а не «не ходи за край».
// Настоящая картографическая конвенция - сплошная линия края с мелкими
// залитыми ТРЕУГОЛЬНИКАМИ-зубцами, основанием к линии, вершиной наружу, в
// сторону обрыва. Спрайт-листа под повторяющуюся текстуру нет (та же
// причина, что и у иконок POI), поэтому рисуется один маленький тайл и
// отдаётся `line-pattern`, который тайлит его вдоль линии.
//
// Базовая полоса занимает всю ширину тайла (не только один повтор), чтобы
// соседние тайлы стыковались в одну непрерывную линию, а не пунктир; зубец -
// это то, что реально повторяется на каждом тайле. В какую сторону смотрит
// зубец, фиксировано тайлом, а не считается на объект - это работает
// корректно только потому, что OSM-конвенция уже оцифровывает
// natural=cliff с обрывом всегда на одной стороне линии.
export const CLIFF_PATTERN_IMAGE_ID = "cliff-hachure";
export const buildCliffHachureImage = (): ImageData | null => {
  const width = 13;
  const height = 15;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  // Тёплый тёмно-серый, а не почти чёрный коричневый - такая плотная
  // штриховка на типичном зуме читалась бы тяжёлой чёрной полосой, выбиваясь
  // из остальной палитры; line-opacity слоя дополнительно смягчает.
  ctx.fillStyle = "#5c5347";
  // Линия края - на всю ширину тайла, чтобы стыковаться в одну непрерывную линию.
  ctx.fillRect(0, 0, width, 1.8);
  // Один зубец: основание к линии края, вершина вниз (сторона «от линии» на этом тайле).
  ctx.beginPath();
  ctx.moveTo(1.5, 1.8);
  ctx.lineTo(width - 1.5, 1.8);
  ctx.lineTo(width / 2, height - 2);
  ctx.closePath();
  ctx.fill();
  return ctx.getImageData(0, 0, width, height);
};

// ── Aerialways (канатные дороги/гондолы/кресельки) ────────────────────────
// Стандартный советский/российский топографический символ «канатная
// дорога» - сплошная линия, пересечённая регулярными перпендикулярными
// насечками (не штрихпунктир, которым на этой карте везде обозначено
// «неясно/сезонно»). Та же техника тайла `line-pattern`, что и у
// buildCliffHachureImage: сплошная база на всю ширину тайла (стык в один
// непрерывный трос) плюс одна перпендикулярная насечка, повторяющаяся вдоль линии.
export const AERIALWAY_PATTERN_IMAGE_ID = "aerialway-tie";
export const buildAerialwayTickImage = (): ImageData | null => {
  const width = 20;
  const height = 7;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  ctx.fillStyle = "#2b2b2b";
  const midY = height / 2;
  ctx.fillRect(0, midY - 0.75, width, 1.5);
  ctx.fillRect(width / 2 - 0.75, 0, 1.5, height);
  return ctx.getImageData(0, 0, width, height);
};
